import { FC } from 'react'
import { type ColumnDef, createColumnHelper } from '@tanstack/react-table'
import { TableWidget } from '@components'
import { trpc } from '@services/trpc'
import type { TableWidgetProps } from '@components/TableWidget'
import { Company } from '@modules/company'

const columnHelper = createColumnHelper<Company>()

// https://github.com/TanStack/table/issues/4382
// eslint-disable-next-line
const columns: ColumnDef<Company, any>[] = [
  columnHelper.accessor((row) => row.name, {
    id: 'name',
    header: 'Name | ID',
  }),
  columnHelper.accessor(() => 'Uncategorized', {
    id: 'company_region',
    header: () => 'Region',
  }),
  columnHelper.accessor(() => 'Default', {
    id: 'company_type',
    header: () => 'Company Type',
  }),
]

interface CompanyTableProps extends Partial<TableWidgetProps<Company>> {}

const CompanyTable: FC<CompanyTableProps> = ({ ...rest }) => {
  const { data: companies = [] } = trpc.api.companies.list.useQuery()

  return (
    <TableWidget<Company>
      {...rest}
      data={companies}
      columns={columns}
      getRowId={(row) => row.id}
      withIndex
    />
  )
}

export default CompanyTable
